<template>
  <div>
    <ed-movimento :key="$root.$session.versao+'1444'"/>
  </div>
</template>

<script>
import EdMovimento from "@/components/movimento/caixa";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdMovimento},
  mounted() {
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>